"use strict";

exports.__esModule = true;
exports.getDefaultLocation = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _calculatePreferencesView = require("../../utils/calculatePreferencesView/calculatePreferencesView");
var _getQueryParams = require("../../utils/getQueryParams");
const getDefaultLocation = ({
  service,
  bookingsSettings,
  serviceOptionsAndVariants,
  openedBy,
  queryParams
}) => {
  var _service$locations;
  const preferencesView = (0, _calculatePreferencesView.calculatePreferencesViewForAppointment)({
    service,
    bookingsSettings,
    serviceOptionsAndVariants,
    openedBy,
    queryParams
  });
  const locationDisplayOnCalendar = preferencesView[_calculatePreferencesView.PreferenceType.LOCATION] === _calculatePreferencesView.DisplayTarget.CALENDAR;
  const hasNoLocations = !((_service$locations = service.locations) != null && _service$locations.length);
  if (locationDisplayOnCalendar || hasNoLocations) {
    return;
  }
  const locationFromUrl = (0, _getQueryParams.getLocationFromUrl)(queryParams);
  if (locationFromUrl) {
    var _service$locations2;
    const matchingLocation = (_service$locations2 = service.locations) == null ? void 0 : _service$locations2.find(location => {
      var _location$business;
      return ((_location$business = location.business) == null ? void 0 : _location$business.id) === locationFromUrl;
    });
    if (matchingLocation) {
      return {
        type: _types.LocationType.BUSINESS,
        value: locationFromUrl
      };
    }
  }
  const sortedLocations = [...service.locations].sort((location1, location2) => getLocationName(location1).localeCompare(getLocationName(location2)));
  const firstLocation = sortedLocations[0];
  return {
    type: firstLocation.type,
    value: getLocationValue(firstLocation)
  };
};
exports.getDefaultLocation = getDefaultLocation;
const getLocationName = location => {
  if (location.type === _types.LocationType.BUSINESS) {
    var _location$business2;
    return ((_location$business2 = location.business) == null ? void 0 : _location$business2.name) || '';
  }
  if (location.type === _types.LocationType.CUSTOM) {
    var _location$custom;
    return ((_location$custom = location.custom) == null || (_location$custom = _location$custom.address) == null ? void 0 : _location$custom.formattedAddress) || '';
  }
  return '';
};
const getLocationValue = location => {
  if (location.type === _types.LocationType.BUSINESS) {
    var _location$business3;
    return ((_location$business3 = location.business) == null ? void 0 : _location$business3.id) || '';
  }
  if (location.type === _types.LocationType.CUSTOM) {
    var _location$custom2;
    return ((_location$custom2 = location.custom) == null || (_location$custom2 = _location$custom2.address) == null ? void 0 : _location$custom2.formattedAddress) || '';
  }
  return '';
};
//# sourceMappingURL=getDefaultLocation.js.map